import "slick-carousel/slick/slick";
import video from "@/modules/video/video";
import { CLASSES } from "@/scripts/helpers/constants";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import Accordion from "@/modules/containers/accordion";
import howToSignBlock from "@/modules/how-to-sign/index";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedSignatureDark2";
import contactForm from "@/modules/blocks/contact-form/index";
import reviewSlider from "@/modules/section-review/index";
import modalShow from "@/modules/containers/modal/modal";
import showMoreCards from "@/pages/e-signature/solution-blocks/index";
import { clampTextHandler } from "@/scripts/helpers/library";

const showMoreGuide = () => {
  const guideLink = $(".guide-link"),
        guideContent = $(".how-to-guide-content"),
        mediaScreenDesktop = 960;

  guideLink.click(function(e) {
    e.preventDefault();
    const $link= $(e.target);
    const $content = $link.prev(guideContent);

    if ($(window).width() > mediaScreenDesktop) {
      const $contentOpen = $(".introduce-text.is-open");

      if ($contentOpen.length < 1) {
        $content.addClass(CLASSES.IS_OPEN);
      } else {
        $content.removeClass(CLASSES.IS_OPEN);

        $('html, body').animate({
          scrollTop: $(".introduce-text").offset().top - 300
        }, 1000);
        return false;
      }
    } else {
      $content.toggleClass(CLASSES.IS_OPEN);
    }

    const htmlLink  = $content.hasClass(CLASSES.IS_OPEN) ? "Read less" : "Read more";
    $link.html(htmlLink);

  });
};

const animationSecond = lottie.loadAnimation({
  animationData: animationData,
  container: document.getElementById("animatedSignatureDark"),
  renderer: 'svg',
  loop: false,
  autoplay: false,
});

const inView = function (element) {
  const win = $(window);
  const obj = element;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const objEndPos = obj.offset().top;

  return visibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const startAnimation = () => {
  const animationBottom = $(".js-ready-animate2");

  if (animationBottom.length) {
    window.addEventListener("scroll", event => {
      if (!$(animationBottom).hasClass("already-played") && inView($(animationBottom))) {
        animationSecond.play();
        $(animationBottom).addClass("already-played");
      }
    });
  }
};

$(document).ready(function() {
  initWowLibrary();
  video();
  Accordion();
  contactForm();
  addedLazyLoadImages();
  howToSignBlock();
  showMoreGuide();
  startAnimation();
  reviewSlider();
  showMoreCards();
  modalShow();
  clampTextHandler(45, ".pages-links-list__link");

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});
